import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  modalContent: {
    maxHeight: ({ fixed }) => (fixed ? '100%' : '60vh'),
    height: ({ height }) => height,
    overflowY: 'auto',
    paddingBottom: ({ fixed }) => fixed && 100
  }
})

function ModalFormContent({ children, fixed, height }) {
  const classes = useStyles({ fixed, height })

  return <div className={classes.modalContent}>{children}</div>
}

export default ModalFormContent
